import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/pages/ValueCalculator.tsx");
